
import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit } from 'lucide-react';
import PersonalInfoEdit from '../PersonalInfoEdit';

interface PersonalInfoSectionProps {
  data: {
    gender: 'Woman' | 'Man' | 'Transgender' | 'Non-binary' | 'Prefer not to respond';
    birthYear: Date;
    weight: string;
    weightUnit: 'kg' | 'lb';
    height: string;
    heightUnit: 'cm' | 'in';
    ethnicity: string;
    wakeUpTime: string;
  };
  editMode: string | null;
  onEditToggle: (section: string) => void;
  onSave: (section: string, data: any) => void;
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({ 
  data, 
  editMode, 
  onEditToggle, 
  onSave 
}) => {
  return (
    <>
      {editMode === 'personalInfo' ? (
        <PersonalInfoEdit 
          data={data} 
          onSave={(data) => onSave('personalInfo', data)}
          onCancel={() => onEditToggle('personalInfo')}
        />
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Gender</span>
              <span className="font-medium">{data.gender}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Birth Year</span>
              <span className="font-medium">{data.birthYear?.getFullYear()}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Weight</span>
              <span className="font-medium">{`${data.weight} ${data.weightUnit}`}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Height</span>
              <span className="font-medium">{`${data.height} ${data.heightUnit}`}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Ethnicity</span>
              <span className="font-medium">{data.ethnicity}</span>
            </div>
            <div className="flex justify-between p-3 bg-muted/50 rounded-md">
              <span className="text-muted-foreground">Wake Up Time</span>
              <span className="font-medium">{data.wakeUpTime}</span>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="mt-2"
            onClick={() => onEditToggle('personalInfo')}
          >
            <Edit className="h-4 w-4 mr-2" />
            Edit Information
          </Button>
        </div>
      )}
    </>
  );
};

export default PersonalInfoSection;
